import type { Highlight } from "@brookbush/types";

import clsx from "clsx";
import { useState } from "react";
import { useDebounce } from "react-use";

interface Props {
	highlight: Highlight | null;
	onChange: (note: string) => void;
}

const AnnotationsNote = ({ highlight, onChange }: Props) => {
	const [note, setNote] = useState<string>(highlight?.note?.body || "");

	useDebounce(() => onChange(note), 500, [note]);

	if (!highlight) return null;

	return (
		<textarea
			placeholder="(Optional) Add a note..."
			rows={4}
			value={note}
			onChange={(e) => setNote(e.target.value)}
			className={clsx(
				"absolute top-14 left-0 phablet:-mr-4 w-80 select-none rounded-lg border px-3 py-2 shadow-black/10 shadow-xl focus:ring-0 dark:border-slate-500 dark:bg-slate-700 dark:text-slate-50 dark:placeholder:text-slate-400",
			)}
		/>
	);
};

export default AnnotationsNote;
